import {SystemAuthenticationService} from "@monex-sistemas/nueva-banca-digital-library";
import {ToastService} from "../toast/toast.service";
import {TokenStatusService} from "../tokenstatus/token-status.service";
import {TranslateService} from "@ngx-translate/core";
import {TokenUnlockService} from "../token-unlock/token-unlock.service";
import {firstValueFrom} from "rxjs"
import {Injectable} from "@angular/core";

@Injectable({providedIn: "root"})
export class ValidateTokenService {

    constructor(
        private systemAuthService: SystemAuthenticationService,
        private tokenStatusService: TokenStatusService,
        private toastService: ToastService,
        private translate: TranslateService,
        private tokenUnlockService: TokenUnlockService
    ) {
    }


    async checkTokenStatus() {
        this.systemAuthService.showLoading();
        let response

        try {
            response = await firstValueFrom(this.tokenStatusService.verifyTokenStatus())
            console.log(response)
        } catch (error) {
            console.log(error);
            this.systemAuthService.hideLoading();
            const errMsg = await firstValueFrom(this.translate.get("STATUS_TOKEN_ERROR"))
            this.toastService.showToast(errMsg);
        }

        if (response?.statusCode == 'AC') {
            this.systemAuthService.hideLoading();
            return true;
        }

        this.systemAuthService.hideLoading();
        const authModal = this.systemAuthService.getRef();
        authModal.close();
        this.tokenUnlockService.openUnlockToken(true);
        return false;
    }
}
